// extracted by mini-css-extract-plugin
var _1 = "BuildingGroupForm-moduleformBody__T7rys";
export { _1 as "formBody" }
